import { SET_INITIAL_DATA, SHOW_GLOBAL_LOADER, HIDE_GLOBAL_LOADER } from './types';

const action = type => payload => ({
  type,
  payload,
});

export const setInitialData = action(SET_INITIAL_DATA);

export const showGlobalLoader = action(SHOW_GLOBAL_LOADER);
export const hideGlobalLoader = action(HIDE_GLOBAL_LOADER);
